import RatedTubeImg from "../../../../../images/png/special-features-images/rated-tube.png";
import CoverSongImg from "../../../../../images/png/special-features-images/cover-song.png";
import RatedAfrikaPlaylist from "../../../../../images/png/special-features-images/rated-afrika-playlist.png";
import RatedFans from "../../../../../images/png/special-features-images//rated-fans.png";
import PromoCards from "../../../../../images/png/special-features-images//promo-cards.png";
import SpotifyCanvas from "../../../../../images/png/special-features-images//spotify-canvas.png";

export const FeatureData = [
  {
    bg: "#F64538",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M19.5617 7C19.7904 5.69523 18.7863 4.5 17.4617 4.5H6.53788C5.21323 4.5 4.20922 5.69523 4.43784 7"
          stroke="white"
          stroke-width="1.5"
        />
        <path
          d="M17.4999 4.5C17.5283 4.24092 17.5425 4.11135 17.5427 4.00435C17.545 2.98072 16.7739 2.12064 15.7561 2.01142C15.6497 2 15.5194 2 15.2588 2H8.74099C8.48035 2 8.35002 2 8.24362 2.01142C7.22584 2.12064 6.45481 2.98072 6.45704 4.00434C6.45727 4.11135 6.47146 4.2409 6.49983 4.5"
          stroke="white"
          stroke-width="1.5"
        />
        <path
          d="M14.5812 13.6159C15.1396 13.9621 15.1396 14.8582 14.5812 15.2044L11.2096 17.2945C10.6669 17.6309 10 17.1931 10 16.5003V12.32C10 11.6273 10.6669 11.1894 11.2096 11.5258L14.5812 13.6159Z"
          stroke="white"
          stroke-width="1.5"
        />
        <path
          d="M2.38351 13.793C1.93748 10.6294 1.71447 9.04765 2.66232 8.02383C3.61017 7 5.29758 7 8.67239 7H15.3276C18.7024 7 20.3898 7 21.3377 8.02383C22.2855 9.04765 22.0625 10.6294 21.6165 13.793L21.1935 16.793C20.8437 19.2739 20.6689 20.5143 19.7717 21.2572C18.8745 22 17.5512 22 14.9046 22H9.09536C6.44881 22 5.12553 22 4.22834 21.2572C3.33115 20.5143 3.15626 19.2739 2.80648 16.793L2.38351 13.793Z"
          stroke="white"
          stroke-width="1.5"
        />
      </svg>
    ),
    title: "Rated-Tube",
    description:
      "Rated-Tube is your gateway to getting your music videos featured on top platforms like Apple Music, Vevo, and Tidal. You can easily distribute your videos, while keeping 100% of your earnings.",
    link: "/overview/rated-tube",
    img: RatedTubeImg
  },
  {
    bg: "#9E37A9",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M4.37012 18.6963L18.3457 18.6963"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <path
          d="M5.14765 13.1992L9.75341 9.54977L12.0126 12.3306L16.6184 8.68116L19.4733 6.26717M19.4733 6.26717L18.9427 10.7882M19.4733 6.26717L14.8878 6.03982"
          stroke="white"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    title: "Pitch Easy",
    description: `Effortlessly pitch your music with a built‑in contact database, one click EPK builder, and step by step PR guide. Connect with labels, curators, and media all from a single, streamlined toolkit.`,
    link: "/overview/pitch-easy",
    img: CoverSongImg
  },
  {
    bg: "#ECAF01",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M21 6H3"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M21 10H3"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M11 14H3"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M11 18H3"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M18.875 14.1183C20.5288 15.0732 21.3558 15.5506 21.4772 16.2394C21.5076 16.4118 21.5076 16.5881 21.4772 16.7604C21.3558 17.4492 20.5288 17.9266 18.875 18.8815C17.2212 19.8363 16.3942 20.3137 15.737 20.0745C15.5725 20.0147 15.4199 19.9265 15.2858 19.814C14.75 19.3644 14.75 18.4096 14.75 16.4999C14.75 14.5902 14.75 13.6354 15.2858 13.1858C15.4199 13.0733 15.5725 12.9852 15.737 12.9253C16.3942 12.6861 17.2212 13.1635 18.875 14.1183Z"
          stroke="white"
          stroke-width="1.5"
        />
      </svg>
    ),
    title: "Rated Afrika Playlist",
    description: `Submit your music for a chance to be featured on our exclusive Rated Afrika playlist. This is a unique opportunity to showcase your talent, reach a wider audience, and gain recognition among listeners.`,
    link: "/overview/rated-afrika-playlist",
    img: RatedAfrikaPlaylist
  },
  {
    bg: "#FF0050",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M11.752 3C9.16609 3 6.68614 4.02723 4.85766 5.85571C3.02918 7.68419 2.00195 10.1641 2.00195 12.75C2.00195 15.3359 3.02918 17.8158 4.85766 19.6443C6.68614 21.4728 9.16609 22.5 11.752 22.5C11.907 22.4996 12.0581 22.4512 12.1845 22.3614C12.3109 22.2717 12.4064 22.1449 12.4578 21.9986C12.5092 21.8524 12.514 21.6937 12.4715 21.5446C12.4291 21.3955 12.3414 21.2632 12.2207 21.1659C12.1157 21.0806 10.2632 19.5422 9.30883 16.5H11.7463C11.9452 16.5 12.136 16.421 12.2767 16.2803C12.4173 16.1397 12.4963 15.9489 12.4963 15.75C12.4963 15.5511 12.4173 15.3603 12.2767 15.2197C12.136 15.079 11.9452 15 11.7463 15H8.94695C8.68827 13.5112 8.68827 11.9888 8.94695 10.5H14.5607C14.6899 11.243 14.7539 11.9959 14.752 12.75C14.752 12.9489 14.831 13.1397 14.9716 13.2803C15.1123 13.421 15.303 13.5 15.502 13.5C15.7009 13.5 15.8916 13.421 16.0323 13.2803C16.1729 13.1397 16.252 12.9489 16.252 12.75C16.2529 11.9967 16.1952 11.2444 16.0795 10.5H19.6898C19.8976 11.2319 20.0026 11.9892 20.002 12.75C20.002 12.9489 20.081 13.1397 20.2216 13.2803C20.3623 13.421 20.553 13.5 20.752 13.5C20.9509 13.5 21.1416 13.421 21.2823 13.2803C21.4229 13.1397 21.502 12.9489 21.502 12.75C21.4992 10.165 20.4711 7.68661 18.6432 5.85872C16.8153 4.03084 14.337 3.00273 11.752 3ZM9.83852 4.725C8.87818 6.00534 8.16882 7.45587 7.74789 9H4.40477C4.94877 7.93784 5.71602 7.00588 6.65391 6.26799C7.5918 5.5301 8.67816 5.00375 9.83852 4.725ZM9.83852 20.775C8.67748 20.4967 7.59039 19.9706 6.65182 19.2327C5.71325 18.4948 4.94542 17.5626 4.40102 16.5H7.74789C8.16882 18.0441 8.87818 19.4947 9.83852 20.775ZM7.42445 15H3.81414C3.39788 13.5289 3.39788 11.9711 3.81414 10.5H7.42445C7.19439 11.9912 7.19439 13.5088 7.42445 15ZM9.31445 9C9.79469 7.42631 10.6284 5.98328 11.752 4.78125C12.8749 5.98367 13.7086 7.42657 14.1895 9H9.31445ZM15.7598 9C15.3388 7.45587 14.6295 6.00534 13.6691 4.725C14.8302 5.00326 15.9173 5.52939 16.8558 6.2673C17.7944 7.00521 18.5622 7.93743 19.1066 9H15.7598Z"
          fill="white"
        />
        <path
          d="M16.1478 15.0226C16.5278 14.3409 16.7179 14 17.002 14C17.2861 14 17.4761 14.3409 17.8561 15.0226L17.9544 15.1989C18.0623 15.3926 18.1162 15.4895 18.2004 15.5534C18.2846 15.6173 18.3895 15.641 18.5992 15.6885L18.7901 15.7317C19.528 15.8986 19.8969 15.9821 19.9847 16.2644C20.0725 16.5466 19.821 16.8408 19.318 17.429L19.1877 17.5812C19.0448 17.7484 18.9734 17.832 18.9412 17.9354C18.9091 18.0388 18.9199 18.1503 18.9415 18.3733L18.9612 18.5764C19.0372 19.3612 19.0753 19.7537 18.8455 19.9281C18.6156 20.1026 18.2702 19.9435 17.5793 19.6254L17.4005 19.5431C17.2041 19.4527 17.1061 19.4075 17.002 19.4075C16.8979 19.4075 16.7998 19.4527 16.6034 19.5431L16.4246 19.6254C15.7337 19.9435 15.3884 20.1026 15.1585 19.9281C14.9287 19.7537 14.9667 19.3612 15.0428 18.5764L15.0625 18.3733C15.0841 18.1503 15.0948 18.0388 15.0627 17.9354C15.0305 17.832 14.9591 17.7484 14.8161 17.5812L14.686 17.429C14.1829 16.8408 13.9314 16.5466 14.0192 16.2644C14.107 15.9821 14.4759 15.8986 15.2138 15.7317L15.4047 15.6885C15.6144 15.641 15.7193 15.6173 15.8035 15.5534C15.8877 15.4895 15.9416 15.3926 16.0495 15.1989L16.1478 15.0226Z"
          stroke="white"
          stroke-width="1.4"
        />
      </svg>
    ),
    title: "RAted Fans",
    description: `Create customizable, free landing page designed to showcase your music, videos, and social media links in one place. This page helps you connect with your audience, making it easy for fans to discover you.`,
    link: "/overview/rated-fans",
    img: RatedFans
  },
  {
    bg: "#017FDD",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M7 9.5C7.82843 9.5 8.5 8.82843 8.5 8C8.5 7.17157 7.82843 6.5 7 6.5C6.17157 6.5 5.5 7.17157 5.5 8C5.5 8.82843 6.17157 9.5 7 9.5Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.9977 11C21 11.4701 21 11.9693 21 12.5C21 16.9783 21 19.2175 19.6088 20.6088C18.2175 22 15.9783 22 11.5 22C7.02166 22 4.78249 22 3.39124 20.6088C2 19.2175 2 16.9783 2 12.5C2 8.02166 2 5.78249 3.39124 4.39124C4.78249 3 7.02166 3 11.5 3C12.0307 3 12.5299 3 13 3.00231"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M18.5 2L18.7579 2.69703C19.0961 3.61102 19.2652 4.06802 19.5986 4.40139C19.932 4.73477 20.389 4.90387 21.303 5.24208L22 5.5L21.303 5.75792C20.389 6.09613 19.932 6.26524 19.5986 6.59861C19.2652 6.93198 19.0961 7.38898 18.7579 8.30297L18.5 9L18.2421 8.30297C17.9039 7.38898 17.7348 6.93198 17.4014 6.59861C17.068 6.26524 16.611 6.09613 15.697 5.75792L15 5.5L15.697 5.24208C16.611 4.90387 17.068 4.73477 17.4014 4.40139C17.7348 4.06802 17.9039 3.61102 18.2421 2.69703L18.5 2Z"
          stroke="white"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <path
          d="M4.5 21.4999C8.87246 16.2749 13.7741 9.38401 20.9975 14.0424"
          stroke="white"
          stroke-width="1.5"
        />
      </svg>
    ),
    title: "Promo Cards",
    description: `Easily create stunning, high-quality images of your album art for free. These visuals are perfect for sharing across all your platforms and showcasing your music in a professional and eye-catching way. `,
    link: "/overview/promo-cards",
    img: PromoCards
  },
  {
    bg: "#1ED760",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 24 24"
        fill="none"
      >
        <rect
          x="3"
          y="4.71436"
          width="10.2857"
          height="14.5714"
          rx="0.857152"
          fill="white"
          fillOpacity="0.2"
        />
        <rect
          x="5.57031"
          y="3.85645"
          width="12"
          height="16.2857"
          rx="0.857152"
          fill="white"
          fillOpacity="0.5"
        />
        <rect
          x="8.14258"
          y="3"
          width="12.8571"
          height="18"
          rx="0.857152"
          fill="white"
        />
      </svg>
    ),
    title: "Spotify Canvas Generator",
    description: `Enhance your Spotify releases with free, custom canvas animations and videos. These personalized visuals add an extra layer of creativity to your tracks, making them more engaging for your audience.`,
    link: "/overview/canvas-generator",
    img: SpotifyCanvas
  }
];
